var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9095 10.841C21.9336 11.0019 23.9577 9.87599 25.2228 8.44852C26.4668 6.98084 27.2891 5.01052 27.0782 3C25.286 3.08042 23.0722 4.12589 21.8071 5.59357C20.6474 6.8602 19.6565 8.91094 19.9095 10.841Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2257 12.8114C21.6173 12.8114 24.1264 11.0622 27.0571 11.223C28.1957 11.3035 31.4849 11.6251 33.5934 14.6007C33.4247 14.7213 29.6927 16.7721 29.7349 21.0746C29.7771 26.2215 34.4578 27.9305 34.5 27.9707C34.4578 28.0913 33.762 30.4034 32.0542 32.7758C30.5572 34.8668 29.018 36.9175 26.5722 36.9577C24.2107 36.9979 23.4306 35.6107 20.7107 35.6107C18.0119 35.6107 17.1263 36.9175 14.8913 36.9979C12.5299 37.0784 10.7377 34.7864 9.24069 32.6954C6.18342 28.4733 3.84304 20.7931 7.00572 15.606C8.5449 13.0124 11.3491 11.3839 14.3642 11.3437C16.6835 11.3035 18.8131 12.8114 20.2257 12.8114Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.da3b3678673899fc868427e5d6e9ff9c.svg";
export { ForwardRef as ReactComponent };